


import React from 'react'
import Banner from "../Component/BannerHome"
import Landingabout from "../Component/Modules/Landingmanagment/Landingabout";
import Landingbanner from "../Component/Modules/Landingmanagment/Landingbanner";
import "./Homes.css";
import { Link } from "react-router-dom";

function Homes() {
  return (
    <div>
      <div className=' home-banner-scrolling'
        style={{
          marginTop: "105px",
          marginBottom: "50px",
          overflow: "auto",
          scrollbarWidth: "none",
          width: "100vw",
          marginLeft: 0,
          padding: 0
        }}>
        <div style={{ width: "100%" }}>
          <Landingbanner />
        </div>
        <div style={{ width: "100%" }}>
          <Landingabout />
        </div>
        <br></br>
      </div>
    </div>
  )
}

export default Homes

